import { Button, Typography } from '@mui/material';
import { LoadingButton } from '@ankr.com/ui';
import { MouseEvent } from 'react';
import { t } from '@ankr.com/common';

import { useProjectDialogContentStyles } from './useProjectDialogContentStyles';

interface IFailedContentProps {
  isLoading: boolean;
  onClose: () => void;
  onTryAgain: (event?: MouseEvent<HTMLButtonElement>) => void;
}

export const FailedContent = ({
  isLoading,
  onClose,
  onTryAgain,
}: IFailedContentProps) => {
  const { classes } = useProjectDialogContentStyles();

  return (
    <div>
      <Typography className={classes.info} component="div">
        {t('jwt-token.failed.info')}
      </Typography>
      <div className={classes.group}>
        <LoadingButton
          fullWidth
          size="large"
          color="error"
          onClick={onTryAgain}
          loading={isLoading}
        >
          {t('jwt-token.failed.try-again')}
        </LoadingButton>
        <Button
          fullWidth
          size="large"
          variant="outlined"
          color="error"
          onClick={onClose}
        >
          {t('jwt-token.close')}
        </Button>
      </div>
    </div>
  );
};
